"use client";

import { BookOpen, Compass, Users } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Sustained Relevant Timely Development",
  description: "Over 75% of our CEO clients worked with us for 5-15 years because of highly relevant, truthful and timely & personalized insights & development that evolve their leadership consciousness as the basis for evolving their business.",
  icon: Compass
}, {
  title: "3-4x Faster Momentum",
  description: "On average our clients gain more momentum & progress in 3-4 months with us than a year without this highest level of leadership consciousness development, protection & support.",
  icon: Users
}, {
  title: "Maverick Legacy Accomplishment",
  description: "Working with our legacy client enabled them to grow from $1 billion to nearly $11 billion in revenue in 11 years in a tight margin highly competitive industry, 10X what they achieved in the previous 90 years.",
  icon: BookOpen
}];
export default function InfoColumns() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="147882" id="centeredcontent" className="py-24 bg-background text-white !h-[500px]">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-6xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-display text-3xl font-bold text-center tracking-tight text-foreground ![margin:-60px_0px_64px_0px] md:text-5xl">Empowering World-Class Leadership Success</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="gap-6 rounded-xl py-6 bg-primary/30 border-white/10 text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] flex flex-col backdrop-blur-md ![margin:-20px_0px_0px_0px] !h-[333px] hover:-translate-y-2 hover:shadow-strong">
                <CardHeader className="pb-4">
                  
                  <h3 className="font-display text-2xl font-semibold leading-tight text-foreground">
                    {service.title}
                  </h3>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="font-sans text-white leading-relaxed ![margin:-20px_0px_0px_0px] !text-lg">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}